import { useId } from 'react'

import { useDisabled, type DisabledState } from './disabled.tsx'

import './form.css'

/**
 * 체크박스 — 와이어프레임 `chk()` 1027행.
 *
 * 와이어프레임은 `<span class="chk">` 라 **키보드로 확약을 못 한다**(§11-4-5).
 * 확약 게이트("위 항목을 확인했습니다")가 이 위에 올라가므로 네이티브 `input` 을 쓴다.
 */
export type CheckboxProps = {
  checked: boolean
  onChange?: ((checked: boolean) => void) | undefined
  /** 라벨(한글). 체크박스 옆에 보인다 */
  label: string
  name?: string | undefined
  /** 고칠 수 없는 «값». 🔴 흐려지지 않는다 — 사정은 `TextInput` 머리말 */
  readOnly?: boolean | undefined
} & DisabledState

export function Checkbox({
  checked,
  onChange,
  label,
  name,
  readOnly,
  disabled,
  disabledReason,
}: CheckboxProps) {
  const id = useId()
  const isReadOnly = readOnly === true
  const { isDisabled, ariaProps, reasonNode } = useDisabled(
    isReadOnly ? false : disabled,
    disabledReason,
  )

  return (
    <label className="a-chk" htmlFor={id} title={ariaProps.title}>
      <input
        aria-describedby={ariaProps['aria-describedby']}
        aria-disabled={ariaProps['aria-disabled']}
        aria-readonly={isReadOnly ? true : undefined}
        checked={checked}
        className="a-chk__input"
        id={id}
        name={name}
        onChange={isDisabled || isReadOnly ? undefined : (e) => onChange?.(e.target.checked)}
        readOnly={isDisabled || isReadOnly}
        type="checkbox"
      />
      {label}
      {reasonNode}
    </label>
  )
}
